import styled, { css } from 'styled-components';

export const Cell = styled.div`
  display: flex;
  ${({ align, cursor = 'inherit', ...rest }) => {
    let aligns = {
      left: 'flex-start',
      right: 'flex-end',
      center: 'center',
    };

    return css`
      justify-content: ${aligns[align]};
      cursor: ${cursor};
    `;
  }}
`;
